import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { format } from 'date-fns';
var ComponentBase = /** @class */ (function (_super) {
    tslib_1.__extends(ComponentBase, _super);
    function ComponentBase() {
        return _super.call(this) || this;
    }
    ComponentBase = tslib_1.__decorate([
        Component({
            filters: {
                date: function (value, formatStr) {
                    if (!value) {
                        return '';
                    }
                    if (formatStr.indexOf('yyyy') > -1) {
                        formatStr = formatStr.replace('yyyy', 'YYYY');
                    }
                    return format(value, formatStr);
                }
            }
        })
    ], ComponentBase);
    return ComponentBase;
}(Vue));
export { ComponentBase };
